(() => {
  const selector = '[data-ww-customers-carousel]';

  class CustomersCarousel {
    constructor(root) {
      if (root.dataset.wwCustomersReady === 'true') return;

      this.root = root;
      this.viewport = root.querySelector('[data-ww-customers-viewport]');
      this.slides = Array.from(root.querySelectorAll('[data-ww-customers-slide]'));
      this.previousButton = root.querySelector('[data-ww-customers-previous]');
      this.nextButton = root.querySelector('[data-ww-customers-next]');
      this.index = 0;
      this.drag = null;
      this.scrollFrame = null;

      if (!this.viewport || this.slides.length === 0) return;

      root.dataset.wwCustomersReady = 'true';
      this.bind();
      this.update(0);
    }

    bind() {
      this.previousButton?.addEventListener('click', () => this.goTo(this.index - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));
      this.viewport.addEventListener('keydown', (event) => this.onKeydown(event));
      this.viewport.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.viewport.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.viewport.addEventListener('pointermove', (event) => this.onPointerMove(event));
      this.viewport.addEventListener('pointerup', (event) => this.onPointerUp(event));
      this.viewport.addEventListener('pointercancel', (event) => this.onPointerUp(event));
    }

    normalizedIndex(index) {
      return (index + this.slides.length) % this.slides.length;
    }

    goTo(index, behavior = 'smooth') {
      const nextIndex = this.normalizedIndex(index);
      this.viewport.scrollTo({
        left: nextIndex * this.viewport.clientWidth,
        behavior
      });
      this.update(nextIndex);
    }

    update(index) {
      this.index = this.normalizedIndex(index);
      this.slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === this.index ? 'false' : 'true');
      });
    }

    onScroll() {
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => {
        const width = this.viewport.clientWidth || 1;
        this.update(Math.round(this.viewport.scrollLeft / width));
      });
    }

    onKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.goTo(this.index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.goTo(this.index + 1);
      } else if (event.key === 'Home') {
        event.preventDefault();
        this.goTo(0);
      } else if (event.key === 'End') {
        event.preventDefault();
        this.goTo(this.slides.length - 1);
      }
    }

    onPointerDown(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;

      this.drag = {
        id: event.pointerId,
        x: event.clientX,
        left: this.viewport.scrollLeft
      };
      this.viewport.setPointerCapture(event.pointerId);
      this.viewport.classList.add('is-dragging');
    }

    onPointerMove(event) {
      if (!this.drag || event.pointerId !== this.drag.id) return;
      const delta = event.clientX - this.drag.x;
      if (Math.abs(delta) > 3) event.preventDefault();
      this.viewport.scrollLeft = this.drag.left - delta;
    }

    onPointerUp(event) {
      if (!this.drag || event.pointerId !== this.drag.id) return;

      if (this.viewport.hasPointerCapture(event.pointerId)) {
        this.viewport.releasePointerCapture(event.pointerId);
      }
      this.viewport.classList.remove('is-dragging');
      this.drag = null;
      this.goTo(Math.round(this.viewport.scrollLeft / (this.viewport.clientWidth || 1)));
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll(selector).forEach((root) => new CustomersCarousel(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
